import { FaceManProfileIcon } from './FaceManProfileIcon';

/**
 * author: Google
 * id 97E9CDDB-45B3-4592-8E1F-0DB66E16E1A3
 * name face-man-profile
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-man-profile.svg
 * tags
 * - People / Family 
 */
export const EmojiManProfileIcon = FaceManProfileIcon;
export default EmojiManProfileIcon